/**
 * AuthPage: the frame every signed-out screen shares: the sign-in, the
 * forgotten password, the reset link, and the authenticator setup a
 * Company's switch sends someone to. One narrow column on the admin's
 * page background, so moving between them reads as one flow.
 */
import type { ReactNode } from "react";
import styles from "./AuthPage.module.css";

export function AuthPage({
  title,
  description,
  children,
}: {
  title: string;
  description?: ReactNode;
  children: ReactNode;
}) {
  return (
    <main className={styles.page}>
      <section className={styles.column}>
        <div className={styles.heading}>
          <p className={styles.mark}>HireOS</p>
          <h1 className={styles.title}>{title}</h1>
          {description ? (
            <p className={styles.description}>{description}</p>
          ) : null}
        </div>
        {children}
      </section>
    </main>
  );
}
